import { FunctionComponent, useState } from "react";
import ModalFiltro from "../../../../components/modalFiltros";
import { Button, Input, Switch } from "@mui/material";


interface ModalFilterProps {
  getConexao: (e?: any) => any
  reset: VoidFunction
}

const ModalFilter: FunctionComponent<ModalFilterProps> = ({ getConexao, reset }) => {


  const [dateInscricao, setDateInscricao] = useState<string>();
  const [batizado, setBatizado] = useState<boolean>(false);
  const [participarPg, setParticiparPg] = useState<boolean>(false);

  function onClear() {
    setDateInscricao(undefined);
    setBatizado(false);
    setParticiparPg(false);
  }

  return (<>
    <ModalFiltro>
      <> <section style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 5, height: 50, borderBottom: '1px solid #ccc' }}>
        <h2 style={{ letterSpacing: 1.2, fontSize: 18 }}>Filtros</h2>
      </section>
        <section style={{ display: 'flex', gap: 8, padding: 4, alignItems: 'center' }}>
          <label htmlFor="" style={{ fontSize: 16 }}>Data:</label>
          <Input type="date" sx={{ fontSize: '16px' }} value={dateInscricao} onChange={(text) => setDateInscricao(text?.target?.value)} />
        </section>
        <section style={{ display: 'flex', gap: 8, padding: 4, alignItems: 'center' }}>
          <label htmlFor="" style={{ fontSize: 16 }}>Batizado:</label>
          <Switch checked={batizado} onClick={() => setBatizado(!batizado)} />
        </section>
        <section style={{ display: 'flex', gap: 8, padding: 4, alignItems: 'center' }}>
          <label htmlFor="" style={{ fontSize: 16 }}>Participar PG:</label>
          <Switch onChange={() => setParticiparPg(!participarPg)} checked={participarPg} />

        </section>

        <section>
          <div style={{ display: 'flex', justifyContent: 'space-between', margin: '4px 0' }}>
            <Button
              onClick={() => { reset(); onClear() }}
              size="large"
              variant="contained"
              color="error">
              Limpar
            </Button>

            <Button
              size="large"
              variant="contained"
              onClick={() => { getConexao({ inscricao: dateInscricao, participarPg, batizado }); }}
            >
              Enviar
            </Button>

          </div>
        </section>
      </>
    </ModalFiltro >
  </>);
}

export default ModalFilter;
